module.exports = __webpack_public_path__ + "static/media/livewellfinder-logo.7b52619a.svg";